module.exports = __webpack_public_path__ + "static/check_yes.9409ad60.svg";